// extracted by mini-css-extract-plugin
export default {"sizeImg":"achivmentTabs_sizeImg__l4l5b"};